(function () {

    'use strict';

    angular.module('numbro', [])
        .provider('numbro', NumbroProvider);

    NumbroProvider.$inject = [
        '$windowProvider'
    ];
    function NumbroProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            setSettings: function (language, settings) {
                $window.numbro.culture(language, settings);
            },
            setLanguage: function (language) {
                $window.numbro.setCulture(language);
            },
            $get: function () {
                return $window.numbro || {};
            }
        };
    }
})();
